import { createReducer, on } from '@ngrx/store';
import { MapStyleState } from './map-style.state';
import * as mapStyleActions from './map-style.actions';

const initialState: MapStyleState = {
  mapStyle: null,
};

export const mapStyleReducer = createReducer(
  initialState,
  on(mapStyleActions.updateMapStyle, (state, { mapStyle }) => ({
    ...state,
    mapStyle,
  }))
);
